<template>
  <Notes :hasFilterContact="true"/>
</template>

<script>
import Notes from '@/views/note/Listnote'

export default {
  name: "NoteContact",
  components:{
    Notes,
  },
}
</script>
